import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/home';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl" style={{ color: 'oklch(0.66 0.140 15)' }}></i>
              </div>
              <span className="text-lg font-bold font-heading">{siteInfo.name}</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">视频分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/category/tv-series" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">最新电视剧</Link></li>
              <li><Link to="/category/movies" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热门电影</Link></li>
              <li><Link to="/category/anime" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">人气动漫</Link></li>
              <li><Link to="/category/variety" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">热播综艺</Link></li>
              <li><Link to="/category/documentary" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">精品纪录片</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4 text-background-50">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">品牌介绍</Link></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">隐私政策</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">免责声明</a></li>
              <li><a href="#" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer">帮助中心</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; 2018-2026 {siteInfo.name} 版权所有 | 粤ICP备XXXXXXXX号
          </p>
          <p className="text-xs text-foreground-400">
            本站内容仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}